'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _coderreviewed = require('./coderreviewed.html');

var _coderreviewed2 = _interopRequireDefault(_coderreviewed);

var _coderreviewed3 = require('./coderreviewed.controller');

var _coderreviewed4 = _interopRequireDefault(_coderreviewed3);

require('./coderreviewed.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var coderreviewedComponent = {
  restrict: 'E',
  bindings: {},
  template: _coderreviewed2.default,
  controller: _coderreviewed4.default,
  controllerAs: 'vm'
};

exports.default = coderreviewedComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/coderreviewed/coderreviewed.component.js